<template lang="html">
<div class="xes-material-model" :style="boxStyle">
  <div class="knowledge-tree">
    <keep-alive>
      <tree
        :is_and_set="0"
        :treeData="knowledges"
        class="tree-fiexd"
        v-if="showTree"
        @tree-change="treeChange"
        ref="tree"
      ></tree>
    </keep-alive>
  </div>
  <el-scrollbar
    :native="false"
    tag="div">
    <div class="material-main">
      <section class="material-filter-box" ref="filterbox">
        <xes-material-filter
          ref="filter"
          :token="token"
          :defaults="filterDefaults"
          :disableds="filterDisables"
          :hides="filterHides"
          :with-credentials="withCredentials"
          :action="actions.getConditions"
          @ajax-success="filterSuccess"
          @status-error="filterStatusError"
          @catch-ajax-error="filterAjaxError"
          @change="filterChange"
          @click-tree="showTree = !showTree"
        ></xes-material-filter>
      </section>
      <section class="material-content-box" ref="listbox">
        <xes-material-list
          ref="list"
          :params="params"
          :token="token"
          :isItemDrag="isItemDrag"
          :withCredentials="withCredentials"
          :blackIds="blackIds"
          :deleteIds="deleteIds"
          :isSingle="isSingle"
          :isMultiple="isMultiple"
          :action="actions.getMaterialList"
          @ajax-success="getListSuccess"
          @status-error="getListStatusError"
          @catch-ajax-error="getListAjaxError"
          @material-drag-start="dragStart"
          @material-drag-end="dragEnd"
          @add-one-material="addOneMaterial"
          @material-add-checks="materialAddChecks"
          @material-delete-checks="materialDeleteChecks"
          @delete-one-material="deleteOneMaterial"
        >
          <template slot="materialInfo" slot-scope="{data,index}">
            <slot name="materialInfo" :data="data" :index="index"></slot>
          </template>
        </xes-material-list>
      </section>
    </div>
  </el-scrollbar>
  <section class="pagenation-box">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="pages.curpage"
      layout="prev, pager, next, jumper"
      :total="pages.total"
      :page-size="perpage"
    ></el-pagination>
  </section>
</div>
</template>

<script>
import XesMaterialList from 'xes-frontend-ui/packages/material-list'
import XesMaterialFilter from 'xes-frontend-ui/packages/material-filter'
import styleMixin from 'xes-frontend-ui/src/mixins/styleMixin'
import tree from 'xes-frontend-ui/packages/question-tree'
import { httpRequest } from 'xes-frontend-ui/src/utils/ajax'
export default {
  name: 'xes-material',
  components: {
    tree,
    XesMaterialList,
    XesMaterialFilter
  },
  mixins: [styleMixin],
  props: {
    height: [String, Number],
    width: [String, Number],
    perpage: {
      type: Number,
      default: 5
    },
    withCredentials: Boolean,
    filterDefaults: {
      type: Object,
      default () {
        return {}
      }
    },
    token: {
      type: String,
      required: true
    },
    filterDisables: {
      type: Object,
      default () {
        return {}
      }
    },
    filterHides: {
      type: Object,
      default () {
        return {}
      }
    },
    isItemDrag: {
      type: Boolean,
      default: false
    },
    blackIds: {
      type: Array,
      default () {
        return []
      }
    },
    deleteIds: {
      type: Array,
      default () {
        return []
      }
    },
    materialChecks: {
      type: Array,
      default () {
        return []
      }
    },
    isSingle: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      originalParams: {
        perpage: 5,
        curpage: 1,
        divisionId: '',
        subjectId: '',
        gradeId: '',
        versionId: '',
        status: '',
        searchType: '',
        searchValue: '',
        sign: ''
      },
      params: {},
      pages: {
        perpage: 5,
        curpage: 1,
        total: 1
      },
      filterList: {
        division: [],
        subject: [],
        grade: [],
        version: [],
        status: [],
        searchType: []
      },
      showTree: false, // 控制知识树展示
      knowledges: []
    }
  },
  watch: {
    filterDefaults (val) {
      this.setDefaultParams()
    }
  },
  created () {
    // 设置默认参数
    this.setDefaultParams()
    this.$nextTick(() => {
      this.getList()
      this.getTreeData()
    })
  },
  mounted () {
  },
  methods: {
    handleHeight () {
      const filterEle = this.$refs.filterbox
      const listEle = this.$refs.listbox
      const filterHeight = filterEle.clientHeight
      listEle.style.height = `calc(100% - ${filterHeight + 20}px)`
    },
    filterSuccess (data) {
      this.$emit('base-success', data)
    },
    filterStatusError (res) {
      this.$emit('base-status-error', res)
    },
    filterAjaxError (err) {
      this.$emit('base-ajax-error', err)
    },
    treeAjaxSuccess (data) {
      this.$emit('tree-success', data)
    },
    treeStatusError (res) {
      this.$emit('tree-status-error', res)
    },
    treeAjaxError (err) {
      this.$emit('tree-ajax-error', err)
    },
    // 根据默认值设置参数
    setDefaultParams () {
      const keys = Object.keys(this.filterDefaults)
      if (keys.length) {
        this.params = Object.assign({}, this.originalParams, this.filterDefaults)
      } else {
        this.params = Object.assign({}, this.originalParams)
      }
      this.params.perpage = this.perpage || 5
      this.pages.perpage = this.perpage || 5
    },
    getList () {
      this.$refs.list.getList().then(() => {
        this.$refs.list.setChecks(this.materialChecks)
      })
    },
    clearChecks () {
      this.$refs.list.clearChecks()
    },
    setChecks (ids) {
      this.$refs.list.setChecks(ids)
    },
    materialAddChecks (checks) {
      this.$emit('material-add-checks', checks)
    },
    materialDeleteChecks (checks) {
      this.$emit('material-delete-checks', checks)
    },
    deleteOneMaterial (material) {
      this.$emit('delete-one-material', material)
    },
    handleCurrentChange (val) {
      this.pages.curpage = val
      this.params.curpage = val
      this.$nextTick(() => {
        this.getList()
      })
    },
    getListSuccess (res) {
      this.pages.total = res.total
      this.$emit('list-success', res)
    },
    filterChange (filters) {
      this.params = Object.assign({}, this.params, filters.data, {
        curpage: 1
      })
      this.pages.curpage = 1
      // 操作的是学部、学科，
      // 只有学部学科都有值，并且改变的是学部学科才请求数据
      if (filters.type === 'division_id' || filters.type === 'subject_id') {
        if (filters.data.divisionId && filters.data.subjectId) {
          this.getTreeData()
        } else if (!filters.data.divisionId || !filters.data.subjectId) {
          // 学部或者学科无数据,清空知识树相关参数
          this.params.knowledge = ''
          this.params.andOr = undefined
          this.knowledges = []
        }
        if (this.$refs.tree) {
          this.$refs.tree.clearData()
        }
      }
      this.$nextTick(() => {
        this.getList()
      })
    },
    // 获取列表数据后端返回状态异常
    getListStatusError (res) {
      this.$emit('list-status-error', res)
    },
    // 获取列表数据后端返回状态异常
    getListAjaxError (err) {
      this.$emit('list-ajax-error', err)
    },
    // 拖拽
    dragStart (ev, item) {
      this.$emit('drag-start', ev, item)
    },
    dragEnd (ev, item) {
      this.$emit('drag-end', ev, item)
    },
    addOneMaterial (material) {
      this.$emit('add-one-material', material)
    },
    // 获取知识树数据
    getTreeData () {
      if (!this.actions.getKnowledgeTree) {
        throw new Error('getKnowledgeTree地址为空！')
      }
      if (!this.params.divisionId || !this.params.subjectId) return
      const params = Object.assign({}, {
        subjectId: this.params.subjectId,
        divisionId: this.params.divisionId
      })
      let options = {
        params,
        headers: Object.assign({}, this.headers, { jytoken: this.token || '' }),
        withCredentials: this.withCredentials,
        action: this.actions.getKnowledgeTree
      }
      httpRequest(options).then(res => {
        if (res.status == 100) {
          this.knowledges = res.data.knowledge_json
          this.$emit('tree-ajax-success', res.data)
        } else {
          this.$emit('tree-status-error', res)
        }
      }).catch(err => {
        this.$emit('tree-ajax-error', err)
      })
    },
    // 选择完知识树
    treeChange (treeParams) {
      this.params = Object.assign({}, this.params, {
        knowledge: treeParams.knowledge_ids,
        andOr: treeParams.is_and_set,
        curpage: 1
      })
      this.pages.curpage = 1
      this.$nextTick(() => {
        this.getList()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// packages/material/src/material.vue